import '../styles/style.scss';
import init from '../../../../pomeloproductions/app/resources/js/init';

import common from './routes/common';
import pageTemplatePageBookIndex from './routes/book-index';

init( {
    common,
    pageTemplatePageBookIndex,
});
